import SvgIcon from '@/assets/svg.svg?react';
import DocIcon from '@/assets/doc.svg?react';
import PngIcon from '@/assets/png.svg?react';
import FolderIcon from '@/assets/folder.svg?react';
import JpgIcon from '@/assets/jpg.svg?react';
import Mp4Icon from '@/assets/mp4.svg?react';
import PdfIcon from '@/assets/pdf.svg?react';
import PsdIcon from '@/assets/psd.svg?react';

const FileIcon = ({
  fileType,
  className,
  size = 18,
}: {
  fileType?: string;
  className?: string;
  size?: number;
}) => {
  switch (fileType) {
    case 'svg':
      return (
        <SvgIcon
          className={className}
          style={{ width: size }}
          aria-label="SVG file"
        />
      );
    case 'doc':
      return (
        <DocIcon
          className={className}
          style={{ width: size }}
          aria-label="DOC file"
        />
      );
    case 'png':
      return (
        <PngIcon
          className={className}
          style={{ width: size }}
          aria-label="PNG file"
        />
      );
    case 'folder':
      return (
        <FolderIcon
          className={className}
          style={{ width: size }}
          aria-label="Folder"
        />
      );
    case 'pdf':
      return (
        <PdfIcon
          className={className}
          style={{ width: size }}
          aria-label="PDF file"
        />
      );
    case 'jpg':
    case 'jpeg':
      return (
        <JpgIcon
          className={className}
          style={{ width: size }}
          aria-label="JPG file"
        />
      );
    case 'mp4':
      return (
        <Mp4Icon
          className={className}
          style={{ width: size }}
          aria-label="MP4 file"
        />
      );
    case 'psd':
      return (
        <PsdIcon
          className={className}
          style={{ width: size }}
          aria-label="PSD file"
        />
      );
    default:
      return null;
  }
};

export default FileIcon;
